<template>
  <div id="app">
      <div class="maincon">
        <div class="tab-tilte">
          <p @click="cur=0" :class="{active:cur==0}" style="margin-left: 0;cursor: pointer;">资源分类</p>
          <p @click="cur=3" :class="{active:cur==3}" style="margin-left: 0;cursor: pointer;">内部讲师</p>
          <p @click="curvideo()" :class="{active:cur==1}" style="cursor: pointer;">内部视频</p>
          <p @click="cursubject()" :class="{active:cur==2}" style="cursor: pointer;">内部题库</p>
        </div>
        <div class="tab-content">
          <Selfclass v-show="cur==0"></Selfclass>
          <Selfvideo v-show="cur==1" ref="Selfvideo"></Selfvideo>
          <selfsubject v-show="cur==2" ref="selfsubject"></selfsubject>
          <selfteacher v-show="cur==3"></selfteacher>
        </div>

</div>
  </div>

</template>

<script>
  import Selfclass from './Class.vue';
  import Selfvideo from './Video.vue';
  import Selfsubject from './Subject.vue';
  import Selfteacher from './Teacher.vue';


  export default {
    data() {
      return {
        cur: 0,
      }
    },
    components: {
      Selfclass: Selfclass,
      Selfvideo: Selfvideo,
      selfsubject: Selfsubject,
      selfteacher: Selfteacher,
    },
      methods: {
        cursubject(){
          let _this=this
          _this.cur=2
          this.$refs.selfsubject.get_subject();
          this.$refs.selfsubject.get_type();
        },
        curvideo(){
          let _this=this
          _this.cur=1
          this.$refs.Selfvideo.get_video();
          this.$refs.Selfvideo.get_type();
          this.$refs.Selfvideo.get_teacher();
        },
      },

  }
</script>

<style scoped>



  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
   overflow-y: auto;
  }

  .tab-tilte {
    height: 41px;
  }

  .tab-tilte>p {
    float: left;
    margin: 0 5px;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #DCDCDC;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    font-size: 15px;
  }

  .active {

    border-bottom: 1px solid white !important;
  }

  .tab-content {
    background-color: white;
    border: 1px solid #DCDCDC;
    min-height: calc(100% - 83px);
    border-radius: 0px 5px 5px 5px;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfCourse/SelfCourse.vue